import { getSolanaAccounts, solanaPoolAddresses } from "@stealthos/sdk";
import type { SolanaJournalRecord } from "./journal";
import type { SolanaRpc } from "./rpc";
import { solanaPoolAccountExists } from "./accounts";

/** A rooted bank after issuance must exclude both the blockhash and receipt. */
export async function depositWindowClosed(
  rpc: SolanaRpc,
  programId: string,
  record: SolanaJournalRecord,
): Promise<boolean> {
  const window = record.deposit?.transactionWindow;
  if (!window || !record.deposit) return false;
  const status = await rpc.request<{
    context: { slot: number };
    value: boolean;
  }>("isBlockhashValid", [
    window.blockhash,
    { commitment: "finalized", minContextSlot: window.slot },
  ]);
  if (
    typeof status?.value !== "boolean" ||
    !Number.isSafeInteger(status.context?.slot) ||
    status.context.slot < window.slot
  )
    throw new Error("RPC returned an invalid deposit expiry bank");
  if (status.value) return false;
  const anchored: SolanaRpc = {
    request: (method, args) =>
      rpc.request(
        method,
        method === "getMultipleAccounts"
          ? [
              args[0],
              { ...(args[1] as object), minContextSlot: status.context.slot },
            ]
          : args,
      ),
  };
  const addresses = solanaPoolAddresses(programId);
  const result = await getSolanaAccounts(
    anchored,
    [addresses.commitmentRecord(record.deposit.commitment as `0x${string}`)],
    "finalized",
  );
  if (result.slot < status.context.slot)
    throw new Error("RPC returned stale deposit expiry evidence");
  return !solanaPoolAccountExists(result.accounts[0], programId, "commitment");
}
